'use client'

import { useState } from 'react'
import { MessagesSquare, X } from 'lucide-react'

import { CustomButton } from '@/components/custom/CustomButton'
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogTitle,
    DialogTrigger,
    DialogHeader
} from '@/components/ui/dialog'
import { ContactForm } from './ContactForm'

const contactDialogSurfaceClassName =
    'flex max-h-[90vh] max-w-2xl flex-col gap-0 overflow-hidden border border-slate-200/80 bg-card p-0 shadow-[0_8px_30px_rgba(15,15,15,0.08)] max-md:fixed max-md:inset-0 max-md:left-0 max-md:top-0 max-md:h-dvh max-md:max-h-dvh max-md:w-full max-md:max-w-full max-md:translate-x-0 max-md:translate-y-0 max-md:rounded-none max-md:border-0 max-md:data-[state=open]:zoom-in-100 max-md:data-[state=closed]:zoom-out-100 max-md:data-[state=open]:slide-in-from-bottom-0 max-md:data-[state=closed]:slide-out-to-bottom-0 sm:max-w-2xl sm:rounded-4xl sm:border sm:border-slate-200/80'

export default function ContactButton() {
    const [isVisible, setVisible] = useState(true)

    return (
        <Dialog>
            {isVisible && (
                <div className='fixed right-6 bottom-6 z-40'>
                    <CustomButton
                        type='button'
                        variant='outline'
                        size='icon'
                        onClick={() => setVisible(false)}
                        aria-label='Hide contact button'
                        className='absolute -top-2 -right-2 z-10 size-9! rounded-full border-0! bg-white! text-darkgrey! shadow-[0_10px_28px_rgba(15,15,15,0.18)] hover:scale-[1.04]! hover:bg-[#f5f5f0]! hover:translate-y-0! hover:shadow-[0_10px_28px_rgba(15,15,15,0.22)]! [&_svg]:size-4!'>
                        <X />
                    </CustomButton>

                    <DialogTrigger asChild>
                        <CustomButton
                            type='button'
                            variant='primary'
                            size='icon'
                            aria-label='Open contact form'
                            className='size-18! min-h-0! rounded-full bg-dark-petrol! text-white! before:rounded-full after:hidden hover:bg-petrol! hover:-translate-y-0.5! hover:scale-[1.04]! shadow-[0_20px_50px_rgba(20,63,63,0.24)] [&_svg]:h-7! [&_svg]:w-7!'>
                            <MessagesSquare />
                        </CustomButton>
                    </DialogTrigger>
                </div>
            )}

            <DialogContent className={contactDialogSurfaceClassName}>
                <DialogDescription className='sr-only'>
                    Contact form: send a message to myworldesk with your name, email, topic, and message.
                </DialogDescription>
                <div className='flex min-h-0 flex-1 flex-col'>
                    <div className='shrink-0 border-b border-border/40 px-5 pb-6 pt-[max(3.5rem,calc(env(safe-area-inset-top)+2.5rem))] sm:px-10 sm:pb-8 sm:pt-10'>
                        <DialogHeader className='space-y-4 text-center sm:space-y-5'>
                            <span className='text-[0.6875rem] font-semibold uppercase tracking-[0.14em] text-petrol'>
                                myworldesk
                            </span>
                            <DialogTitle className='text-2xl font-extrabold leading-tight tracking-[-0.03em] text-darkgrey [font-family:var(--font-newblack),var(--font-poppins),system-ui,sans-serif] sm:text-3xl'>
                                How can we help you?
                            </DialogTitle>
                        </DialogHeader>
                        <p className='mx-auto mt-4 max-w-prose text-center text-sm leading-relaxed text-muted-foreground sm:mt-5 sm:text-base'>
                            Tell us what you need and we’ll respond within 24 hours.
                        </p>
                    </div>
                    <div className='min-h-0 flex-1 overflow-y-auto overscroll-contain px-7 py-6 sm:px-12 sm:py-10'>
                        <div className='mx-auto w-full max-w-prose'>
                            <ContactForm />
                        </div>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    )
}
